var React = require('react');

function NavIconsExperienceDevelop (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"m6.2 14.74-.78.79-3.71-3.72 3.71-3.71.78.78-2.93 2.93z","key":0}),React.createElement("path",{"d":"m22.3 11.81-3.72 3.72-.78-.79 2.93-2.93-2.93-2.93.78-.78z","key":1}),React.createElement("path",{"d":"m9.66 19.41-3.21-1.86 7.45-12.91 3.22 1.86zm-2.2-2.13 1.93 1.12 6.72-11.63-1.94-1.12z","key":2}),React.createElement("path",{"d":"m6.05 21.67.95-4.67 3 1.73zm1.43-3.52-.34 1.76 1.47-1.11z","key":3}),React.createElement("path",{"d":"m16.49 6.94-2.66-1.53 1.78-3.08 2.66 1.53zm-1.65-1.81 1.38.8 1-1.79-1.38-.8z","key":4}),React.createElement("path",{"d":"m15.37 3.75h.74v2.44h-.74z","transform":"matrix(.5 -.8660254 .8660254 .5 3.57 16.12)","key":5})]);
}

NavIconsExperienceDevelop.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = NavIconsExperienceDevelop;

NavIconsExperienceDevelop.default = NavIconsExperienceDevelop;
